import { render, staticRenderFns } from "./Relax.vue?vue&type=template&id=4e586258&scoped=true&"
import script from "./Relax.vue?vue&type=script&lang=js&"
export * from "./Relax.vue?vue&type=script&lang=js&"
import style0 from "./Relax.vue?vue&type=style&index=0&id=4e586258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e586258",
  null
  
)

export default component.exports